import { IWatermarkSet } from '@/types/watermarks.types';
import { Get } from '../helpers';
import { watermarkPath } from './path';

export default function GetWatermarksByChannel({ channel }: { channel: number }) {
  return Get<IWatermarkSet[]>({
    path: watermarkPath(channel),
  });
}
